export default {
  toggle: ({commit, state}, value) => {
    return new Promise((resolve, reject) => {
      commit('toggleActive', value)
      resolve(state)
    })
  },
}